
// Favorites!!
export function fnc_fav_init() {
  jQuery(".fnc-fav").each(function () {
    jQuery(this).on("vmousedown click", function (e) {
      e.preventDefault();

      var this_btn = jQuery(this);

      var data_otype = jQuery(this_btn).data("otype");
      var data_oid = jQuery(this_btn).data("oid");
      var data_clearparent = jQuery(this_btn).data("clear-parent");

      jQuery.ajax({
        url: ThisThemeAJAX.admin_ajax,
        type: "post",
        dataType: "json",
        data: {
          action: "_fav_btn",
          otype: data_otype,
          oid: data_oid,
          clearparent: data_clearparent,
          lang: ThisThemeAJAX.lang,
        },

        success: function (response) {
          if (response.data.action == "deleted") {
            if (data_clearparent !== undefined && data_clearparent != "")
              jQuery(this_btn).closest(data_clearparent).remove();

            jQuery(this_btn).removeClass("fav-on");
          } else if ("added" == response.data.action) {
            jQuery(this_btn).addClass("fav-on");
          }

          var dataCounters = Object.entries(response.data.counters);
          for (let [keyCounter, valueCounter] of dataCounters) {
            jQuery(".fav-counter-" + keyCounter)
              .replaceWith(valueCounter)
              .closest("a")
              .removeClass("fav-on");
            if (response.data.counters_n[keyCounter] > 0) {
              jQuery(".fav-counter-" + keyCounter)
                .closest("a")
                .addClass("fav-on");
            }
          }
        },

        error: function (response) {
          console.log("Error en la petición");
        },
      });

      return false;
    });
  });

  jQuery(".fav-counter-total").each(function () {
    if (jQuery(this).text() > 0) jQuery(this).closest("a").addClass("fav-on");
  });
}